import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'

const initialState = {
  data: [],
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        data: action.payload,
      }
    case RESET:
      return {
        isLoading: false,
        error: null,
        data: [],
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
